export default __webpack_public_path__ + "static/media/Jama_Masjid_-_In_the_Noon.d8351dfe.jpg";